/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeteredUsage } from './MeteredUsage';
import {
    MeteredUsageFromJSON,
    MeteredUsageFromJSONTyped,
    MeteredUsageToJSON,
    MeteredUsageToJSONTyped,
} from './MeteredUsage';
import type { MeteredItem } from './MeteredItem';
import {
    MeteredItemFromJSON,
    MeteredItemFromJSONTyped,
    MeteredItemToJSON,
    MeteredItemToJSONTyped,
} from './MeteredItem';

/**
 *
 * @export
 * @interface BillingDemoDetails
 */
export interface BillingDemoDetails {
    /**
     *
     * @type {boolean}
     * @memberof BillingDemoDetails
     */
    billingEnabled: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BillingDemoDetails
     */
    hasAccess: boolean;
    /**
     *
     * @type {string}
     * @memberof BillingDemoDetails
     */
    reason: string | null;
    /**
     *
     * @type {string}
     * @memberof BillingDemoDetails
     */
    subscriptionName: string | null;
    /**
     *
     * @type {Array<MeteredItem>}
     * @memberof BillingDemoDetails
     */
    meteredItems: Array<MeteredItem>;
    /**
     *
     * @type {Array<MeteredUsage>}
     * @memberof BillingDemoDetails
     */
    usageRecords: Array<MeteredUsage>;
}

/**
 * Check if a given object implements the BillingDemoDetails interface.
 */
export function instanceOfBillingDemoDetails(value: object): value is BillingDemoDetails {
    if (!('billingEnabled' in value) || value['billingEnabled'] === undefined) return false;
    if (!('hasAccess' in value) || value['hasAccess'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('subscriptionName' in value) || value['subscriptionName'] === undefined) return false;
    if (!('meteredItems' in value) || value['meteredItems'] === undefined) return false;
    if (!('usageRecords' in value) || value['usageRecords'] === undefined) return false;
    return true;
}

export function BillingDemoDetailsFromJSON(json: any): BillingDemoDetails {
    return BillingDemoDetailsFromJSONTyped(json, false);
}

export function BillingDemoDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDemoDetails {
    if (json == null) {
        return json;
    }
    return {

        'billingEnabled': json['billing_enabled'],
        'hasAccess': json['has_access'],
        'reason': json['reason'],
        'subscriptionName': json['subscription_name'],
        'meteredItems': ((json['metered_items'] as Array<any>).map(MeteredItemFromJSON)),
        'usageRecords': ((json['usage_records'] as Array<any>).map(MeteredUsageFromJSON)),
    };
}

  export function BillingDemoDetailsToJSON(json: any): BillingDemoDetails {
      return BillingDemoDetailsToJSONTyped(json, false);
  }

  export function BillingDemoDetailsToJSONTyped(value?: BillingDemoDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'billing_enabled': value['billingEnabled'],
        'has_access': value['hasAccess'],
        'reason': value['reason'],
        'subscription_name': value['subscriptionName'],
        'metered_items': ((value['meteredItems'] as Array<any>).map(MeteredItemToJSON)),
        'usage_records': ((value['usageRecords'] as Array<any>).map(MeteredUsageToJSON)),
    };
}
